const STATUSES = {
  email: {
    sent: { label: 'Sent', tone: 'neutral' },
    deferred: { label: 'Delayed', tone: 'warning' },
    soft_bounce: { label: 'Soft bounce', tone: 'warning' },
    delivered: { label: 'Delivered', tone: 'success' },
    opened: { label: 'Opened', tone: 'success' },
    clicked: { label: 'Clicked', tone: 'success' },
    unsubscribed: { label: 'Unsubscribed', tone: 'warning' },
    spam: { label: 'Spam complaint', tone: 'error' },
    hard_bounce: { label: 'Bounced', tone: 'error' },
    blocked: { label: 'Blocked', tone: 'error' },
    invalid: { label: 'Invalid address', tone: 'error' },
    failed: { label: 'Failed', tone: 'error' },
  },
  sms: {
    queued: { label: 'Queued', tone: 'neutral' },
    sent: { label: 'Sent', tone: 'neutral' },
    delivered: { label: 'Delivered', tone: 'success' },
    undelivered: { label: 'Undelivered', tone: 'error' },
    failed: { label: 'Failed', tone: 'error' },
  },
}

const PENDING_STATUSES = {
  email: ['sent', 'deferred', 'soft_bounce'],
  sms: ['queued', 'sent'],
}

const PENDING_WINDOW_MS = 24 * 60 * 60 * 1000

const has = (object, key) => Object.prototype.hasOwnProperty.call(object, key)

const find = (channel, status) => {
  if (!has(STATUSES, channel) || !has(STATUSES[channel], status)) return undefined
  return STATUSES[channel][status]
}

export const deliveryLabel = (channel, status) => {
  const known = find(channel, status)
  if (known) return known.label
  return status === undefined || status === null ? '' : String(status)
}

export const deliveryTone = (channel, status) => find(channel, status)?.tone ?? 'neutral'

export const isPendingDelivery = (channel, status, createdAt, now = Date.now()) => {
  if (!has(PENDING_STATUSES, channel) || !PENDING_STATUSES[channel].includes(status)) return false
  const created = new Date(createdAt).getTime()
  if (Number.isNaN(created)) return false
  return now - created < PENDING_WINDOW_MS
}
